function parseRule(rule){
    var parsedRule = {};

    if(rule.indexOf('block') >= 0){
        parsedRule.type = "block";

        const sampleRegex = /block\.sample\s*\(((\s*\w+\s*,)+)\s*(\d+)\s*\)/gm;
        const selectRegex = /block\.select\s*\(((\s*\w+\s*,)+)\s*(\d+)\s*\)/gm;
        var matches;
        if(matches = sampleRegex.exec(rule)){
            blocks = matches[1].split(',');
            blocks.pop();
            for(var i = 0; i < blocks.length; i++){
                blocks[i] = blocks[i].trim(); 
            }
            sampleSize = matches[3];
            parsedRule.function = "sample";
            parsedRule.blocks = blocks;
            parsedRule.size = sampleSize;
        }
        
        if(matches = selectRegex.exec(rule)){
            blocks = matches[1].split(',');
            blocks.pop();
            for(var i = 0; i < blocks.length; i++){
                blocks[i] = blocks[i].trim(); 
            }
            sampleSize = matches[3];
            parsedRule.function = "select";
            parsedRule.blocks = blocks;
            parsedRule.size = sampleSize;
        }
    }
    return parsedRule;
}


function applyRules(){
    const rules = window.trialData['rules'];
    for(var i = 0; i < rules.length; i++){
        var currentRule = parseRule(rules[i]);

        if(currentRule.type == "block"){
            applyBlockRule(currentRule);
            continue;
        }
    }
}

function applyBlockRule(rule){
    if(rule.function == "sample"){
        window.randomBlockPick(rule);
    }

    if(rule.function == "select"){
        window.pickBlocks(rule);
    }
}